import React from 'react'
import LandingSection from '../../sections/Home/LandingSection/LandingSection'
import CommunitySection from '../../sections/Home/CommunitySection/CommunitySection'
import HubSection from '../../sections/Home/HubSection/HubSection'
import SecuredSection from '../../sections/Home/SecuredSection/SecuredSection'
import BeAPartSection from '../../sections/Home/BeAPartSection/BeAPartSection'
import TechnologySection from '../../sections/Home/TechnologySection/TechnologySection'
import JoinNetworkSection from '../../sections/Home/JoinNetworkSection/JoinNetworkSection'
import FaqSection from '../../sections/Home/FaqSection/FaqSection'
import TeamSection from '../../sections/Home/TeamSection/TeamSection'

const HomePage = () => {
  return (
    <div className='w-full'>
      <div className='flex justify-center w-full bg-landingSection'>
        <LandingSection />
      </div>
      <div className='flex justify-center w-full bg-communitySection'>
        <CommunitySection />
      </div>
      <div className='flex justify-center w-full'>
        <HubSection />
      </div>
      <div className='flex justify-center w-full'>
        <SecuredSection />
      </div>
      <div className='flex justify-center w-full'>
        <BeAPartSection />
      </div>
      <div className='flex justify-center w-full bg-techSection'>
        <TechnologySection />
      </div>
      <div className='flex justify-center w-full'>
        <TeamSection />
      </div>
      <div className='flex justify-center w-full'>
        <JoinNetworkSection />
      </div>
      <div className='flex justify-center w-full'>
        <FaqSection />
      </div>
    </div>
  )
}

export default HomePage
